import initialState from './UsersInitialState';
import reducers from './UsersReducer';

export default {
  initialState,
  reducers,
};
